import { Container } from '@patsnap/tahiti-core/shared/inversify';
import { baseModule } from '@/container-modules/base-module';
import { serviceApiModule } from '@/container-modules/service-api-module';
import { documentModule } from '@/container-modules/document-module';
import { componentModule } from '@/container-modules/component-module';

const container = new Container({
    defaultScope: 'Singleton',
    skipBaseClassChecks: true,
});

container.load(
    baseModule,
    serviceApiModule,
    documentModule,
    componentModule,
);

export {
    container,
};
